import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 18.99h12.04L21 12l-4.97-7H4l5 7-5 6.99z"
}), 'LabelImportantSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LabelImportantSharp.js
// module id = 4379
// module chunks = 2